import { render, staticRenderFns } from "./HintLabels.vue?vue&type=template&id=0997c71a&"
import script from "./HintLabels.vue?vue&type=script&lang=js&"
export * from "./HintLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports